import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { AnalyticsService } from './core/services/analytics/analytics-service';
import { LanguageService } from './core/services/language/language.service';
import { SessionService } from './core/services/session/session-service';

import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private analyticsService: AnalyticsService,
    private sessionService: SessionService,
    private languageService: LanguageService,
    private router: Router,
  ) {
    this.languageService.setDefaultLanguage();
    this.setGoogleAnalyticsConfig();
  }

  setGoogleAnalyticsConfig(): void {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        const sessionId = this.sessionService.getSessionId();
        this.analyticsService.setAnalyticsConfig(event.urlAfterRedirects, sessionId);
      });
  }
}
